import type { Project } from '../types'

export const projectsData: Project[] = [
  {
    title: 'Louis Vuitton, Echoes of the Jura',
    type: 'Music Composition',
    description:
      "Echoes of the Jura. Channeling the birthplace of Louis Vuitton's founder, Nicolas Ghesquière composes the Fall-Winter 2026 collection through pastoral prints and instinctive tailoring, giving new expression to the House's Art of Travel.",
    videoSrc: 'louisvuitton.mp4',
    scrollMultiplier: 0.28,
    credits: {
      'Campaign Name': 'Echoes of the Jura',
      Client: 'Louis Vuitton',
      Director: 'Roman Wygas',
      'Production Company': 'Farago Projects',
    },
  },
  {
    title: 'G-Shock, Your Beat, Your Life',
    type: 'Music Composition + Post-Production',
    description:
      '"Your Beat, Your Life." / "鼓動はあるか。生きているか。" G-SHOCK Global Campaign 2026. Starring Yuto Horigome, Kanoa Igarashi, Rush Ball and XG.',
    videoSrc: 'gshock.mp4',
    scrollMultiplier: 0.32,
    credits: {
      'Campaign Name': 'Your Beat, Your Life',
      Client: 'G-Shock',
      'Creative Agency': 'THOUSAND incl',
      Director: 'Oudai Kojima',
      'Production Company': 'NAKAMA',
    },
  },
  {
    title: 'Samsung, You and AI as One',
    type: 'Music Composition',
    description:
      "Ariela Dorf's beautiful new spot for Samsung 'You and AI as One'.",
    videoSrc: 'samsung2.mp4',
    scrollMultiplier: 0.24,
    credits: {
      'Campaign Name': 'You And I as One 2',
      Client: 'Samsung',
      'Creative Agency': 'Exposure',
      Director: 'Ariela Dorf',
      'Production Company': 'Believe Media',
    },
  },
  {
    title: 'Hennessy, The Final Decision',
    type: 'Music Composition + Edit',
    description: 'A decision for the history books.',
    videoSrc: 'hennessy.mp4',
    scrollMultiplier: 0.3,
    credits: {
      'Campaign Name': 'The Final Decision',
      Client: 'Hennessy',
      'Creative Agency': 'Wieden+Kennedy',
      Director: 'Andreas Nilsson',
      'Production Company': 'Biscuit Filmworks',
    },
  },
  {
    title: 'Nike, Pegasus 41',
    type: 'Music Composition + Edit',
    description:
      "On Global Running Day, with the latest launch of Nike's original and most iconic running shoe: the Pegasus, we inspired the international running community. 41 runners from 13 countries embarked on a 272.4km journey from Mount Helicon to Mount Olympus in the run of a lifetime: the Pegasus Relay.",
    videoSrc: 'project1-nike.mp4',
    scrollMultiplier: 0.2,
    credits: {
      'Campaign Name': 'Pegasus 41',
      Client: 'Nike',
      'Creative Agency': 'Soursop, Amsterdam',
      Director: 'Arthur Couvat',
      'Production Company': 'UNIT9 Films, London',
    },
  },
  {
    title: "Nike, Charles-Antoine Kouakou - Winning isn't for Everyone",
    type: 'Edit',
    description:
      'For summer 2024, Nike unveiled the "Winning Isn\'t for Everyone" campaign, featuring a collective of the world\'s greatest athletes, all motivated by victory. Charles-Antoine never expected anything less. His rise to the top (Gold at the Tokyo Paralympics 2021) has proven to his community, the world and himself that the only limits that matter are the ones you set yourself.',
    videoSrc: 'project4-nike.mp4',
    scrollMultiplier: 0.38,
    credits: {
      'Campaign Name': "Winning Isn't For Everyone",
      Client: 'Nike',
      'Creative Agency': 'We Are Pi',
      Director: 'Kim Gehrig',
    },
  },
  {
    title: 'Samsung, As One',
    type: 'Music Supervision + Licensing',
    description:
      "'You + AI. As One' takes a customer-centric approach supporting a range of the technology giant's product lines, including mobile, TV/AV, and home appliances. The spot showcases how these technologies can simplify and enrich everyday experiences.",
    videoSrc: 'project-samsung.mp4',
    scrollMultiplier: 0.24,
    credits: {
      'Campaign Name': 'As One',
      Client: 'Samsung',
      'Creative Agency': 'Exposure, London',
      Director: 'Ariela Dorf',
      'Production Company': 'Believe Media, London',
    },
  },
  {
    title: 'OnePlus x Hasselblad, The Perfect Shots',
    type: 'Music Composition + Edit + Direction',
    description:
      '3 Hasselblad ambassadors share their perfect shots using the new OnePlus flagship phone to prove that it all begins with a simple thought…and maybe climbing a mountain or two. We followed three of Hasselblad\'s own ambassadors into their fields to demonstrate the camera features of OnePlus\'s newest flagship device…in the process exploring memories, venturing into rural China, and scaling the heights of Norwegian mountains alongside these master photographers to highlight the versatile capabilities of the OnePlus 9, and to show how every perfect image always begins with one simple thought.',
    videoSrc: 'project5-oneplusx.mp4',
    scrollMultiplier: 0.52,
    credits: {
      'Campaign Name': 'It all begins with a simple thought',
      Client: 'OnePlus',
      'Creative Agency': 'Mother Shanghai',
      Director: 'Hiro Ikematsu',
    },
  },
  {
    title: 'The Woolmark Company, Live with Nature',
    type: 'Music Composition + Edit + Direction',
    description:
      'On World Earth Day, we unveiled Nest Starter, an art installation created in collaboration between local weavers and The Woolmark Company to launch the brand\'s "Merino Wool. Live with Nature." platform in China. Located high up on Laojun Mountain, this installation aims to highlight how 100% natural and biodegradable Merino Wool can contribute to sustainability by becoming the ideal nesting material for Yunnan\'s over 194 species of birds (as well as the ideal clothing material for impact-conscious humans).',
    videoSrc: 'project6-woolmark.mp4',
    scrollMultiplier: 0.5,
    credits: {
      Client: 'The Woolmark Company',
      'Creative Agency': 'Mother Shanghai',
      Director: 'Hiro Ikematsu',
      'Production Company': 'PLAYFilms Shanghai',
    },
  },
  {
    title: 'Montblanc, What Moves You, Makes You',
    type: 'Music Composition + Edit',
    description:
      "A global campaign for Montblanc, 'What Moves You, Makes You' inspires people to express their full potential on their own terms, and celebrates those who have found their own original path to rewriting the codes of success for the 21st century. With the help of three exceptional individuals who are redefining what success means today – writer and director Spike Lee, actor Taron Egerton and singer, actor and writer Chen Kun – the Luxury Maison reintroduced itself to the world.",
    videoSrc: 'project7-montblanc.mp4',
    scrollMultiplier: 0.42,
    credits: {
      Client: 'Montblanc',
      'Creative Agency': 'Wieden+Kennedy Amsterdam',
      Director: 'Geordie Wood',
      'Production Company': 'CLM, Iconoclast',
    },
  },
]
